import { render, staticRenderFns } from "./PayoutDetail.vue?vue&type=template&id=4b83c236&"
import script from "./PayoutDetail.vue?vue&type=script&lang=js&"
export * from "./PayoutDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports